export default __webpack_public_path__ + "static/media/opening.5fe1a56a.png";